import { Box } from "@chakra-ui/react";
import React, { Component } from "react";
import { connect } from "react-redux";
import SlideLayerItem from "./SlideLayerItem";
import { TldrUnlockWarningDialog } from "../../../common/statelessView";
import {
  arrayMove,
  SortableContainer,
  SortableElement,
} from "react-sortable-hoc";
import { wsUpdateLayers } from "../../../../_actions/webSocketAction";

const SortableLayerItem = SortableElement(
  ({ layerstoreLayer, layer, canvasRef, isSorting, onSelect }) => {
    const onToggleVisibility = (layerId, value) => {
      canvasRef.handler.objectHandler.visible(layerId, value);
    };

    return (
      <SlideLayerItem
        onSelect={onSelect}
        onToggleVisibility={onToggleVisibility}
        layer={layer}
        canvasRef={canvasRef}
        location="edit"
        layerTitle={layerstoreLayer ? layerstoreLayer.title : ""}
        showExtraIcons={true}
        isSorting={isSorting}
      />
    );
  }
);

const SortableLayersContainer = SortableContainer(
  ({ canvasRef, layerstore, currentPageLayers, isSorting, onSelect }) => {
    return (
      <ul>
        {currentPageLayers.map((layer, index) => {
          const layerId = layer.id;
          const layerstoreLayer = layerstore.layers[layerId];

          return (
            <SortableLayerItem
              key={layerId}
              layerstoreLayer={layerstoreLayer}
              layer={layer}
              canvasRef={canvasRef}
              index={index}
              isSorting={isSorting}
              onSelect={onSelect}
            />
          );
        })}
      </ul>
    );
  }
);

class SlideLayers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showUnlockDialog: false,
      selectedLayer: null,
      currentPageLayers: [],
      isSorting: false,
    };
  }

  componentDidMount() {
    this.setState({
      currentPageLayers: this.props.canvasRef.handler.getObjects().reverse(),
    });
  }

  onSelect = (layerId, action) => {
    if (action === "unlock") {
      this.setState({
        ...this.state,
        selectedLayer: layerId,
        showUnlockDialog: true,
      });
    } else if (action === "select") {
      this.props.canvasRef.handler.searchAndSelect(layerId);
    }
  };

  onSortEnd({ oldIndex, newIndex }) {
    const { wsUpdateLayers, activePage, canvasRef } = this.props;
    const { currentPageLayers } = this.state;
    const { canvas, handler } = canvasRef;

    const newCurrentPageLayers = arrayMove(
      currentPageLayers,
      oldIndex,
      newIndex
    );

    const canvasObjects = canvas.getObjects();

    const oldIndexElem = canvasObjects.find(
      (item) => item.id === currentPageLayers[oldIndex].id
    );
    const newIndexElem = canvasObjects.find(
      (item) => item.id === currentPageLayers[newIndex].id
    );

    const newIndexElemIndexInCanvas = canvasObjects.indexOf(newIndexElem);

    canvas.moveTo(oldIndexElem, newIndexElemIndexInCanvas, true);

    canvas.renderAll();

    this.setState({
      currentPageLayers: newCurrentPageLayers,
      isSorting: false,
    });

    const orderedLayers = handler
      .getLayersPayload()
      .map((layer, index) => ({ ...layer, order: index }));
    wsUpdateLayers(orderedLayers, activePage.id);
  }

  render() {
    const { currentPageLayers, isSorting, showUnlockDialog } = this.state;
    const { canvasRef, layerstore } = this.props;

    return (
      <>
        <Box 
          flex={1} 
          flexBasis={0} 
          overflow={"hidden auto"} 
          pr={3}
          sx={{
            "::-webkit-scrollbar-track": {
              backgroundColor: "transparent"
            },
            "::-webkit-scrollbar-track-piece": {
              backgroundColor: "transparent"
            }
          }}
          >
          <SortableLayersContainer
            distance={1}
            lockAxis="y"
            helperClass="draggable-layer"
            canvasRef={canvasRef}
            layerstore={layerstore}
            currentPageLayers={currentPageLayers}
            onSortStart={() => this.setState({ isSorting: true })}
            onSortEnd={(sort) => this.onSortEnd(sort)}
            isSorting={isSorting}
            onSelect={this.onSelect}
          />
        </Box>
        <TldrUnlockWarningDialog
          show={showUnlockDialog}
          onHide={() => {
            this.setState({
              ...this.state,
              showUnlockDialog: false,
            });
          }}
          onYes={() => {
            this.setState({
              ...this.state,
              showUnlockDialog: false,
            });

            canvasRef.handler.unlockThisLayer(this.state.selectedLayer);
          }}
        />
      </>
    );
  }
}

SlideLayers.propTypes = {};

const mapStateToProps = (state) => ({
  layerstore: state.layerstore,
  activePage: state.editor.activePage,
});

const mapDispatchToProps = (dispatch) => ({
  wsUpdateLayers: (layers, pageId) => dispatch(wsUpdateLayers(layers, pageId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SlideLayers);
